import React from 'react';

interface ScrollableContentProps {
    children: React.ReactNode;
    additionalClasses?: string;
}

const ScrollableContent: React.FC<ScrollableContentProps> = (props) => {
    const { children, additionalClasses } = props;

    return (
        <div className={`${additionalClasses}`} style={{ maxHeight: '500px', overflowY: 'scroll' }}>
            {children}
        </div>
    );
};

export default ScrollableContent;
